import { useCallback } from "react";
import { getOptionByIdWithCORP } from "../../api/TabwareOptions";
import { logCustomMessage } from "../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetDefaultWOCompletionStatus() {
  const setWoDefaultCompletionStatus = useWorkOrderStore(
    (state) => state.setWoDefaultCompletionStatus
  );
  const getDefaultWOCompletionStatus = useCallback(async () => {
    const response = await getOptionByIdWithCORP("WOCompletionStatus");
    const data = {
      OptionId: "WOCompletionStatus",
    };
    logCustomMessage(
      "Get Default Status in Complete screen",
      SeverityLevel.Information,
      "TabwareOptions/GetOptionByIdWithCORP",
      data,
      response
    );
    const defaultStatus =
      response.data?.PlantValue || response.data?.DefaultValue;
    setWoDefaultCompletionStatus(defaultStatus ?? "");
  }, [setWoDefaultCompletionStatus]);

  return { getDefaultWOCompletionStatus };
}
